import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { useStore } from "vuex";
  import { getFirstLastName } from "@/helpers/user";
  import { copyToClipboard } from "@/helpers/copyToClipboard";
  import { formatStripePrice } from "@/helpers/transformation/price";
  import getUserRole from "@/helpers/getUserRole";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandownerEstates',
  setup(__props, { expose: __expose }) {
  __expose();

  const canEdit = (estate: EstateInterface) => {
    if (isSalesPersonRole.value) return false;

    return estate.landownerId._id === store.state.user.data._id;
  };

  const store = useStore();
  const estates = computed(
    () => store.state.user.landownerEstates as EstateInterface[]
  );
  const { isSalesPersonRole, isLandownerRole } = getUserRole();
  const landownerDetails = ref({});
  const lawyerName = (estate) => {
    if (estate.lawyerId && typeof estate.lawyerId === "object") {
      const { firstName, lastName } = estate.lawyerId;

      return `${firstName} ${lastName}`;
    }

    return "";
  };
  const isLawyerIdIsObject = (lawyerId: string | unknown) => {
    return typeof lawyerId === "object";
  };
  const loading = ref(false);

  onMounted(() => {
    loading.value = true;
    getEstates()
      .then((data) => {
        store.commit("user/setLandownerEstates", data);
      })
      .finally(() => {
        loading.value = false;
      });
  });

  const getEstates = () => {
    if (isLandownerRole.value) {
      return store
        .dispatch("estate/getEstates", {
          landownerId: store.state.user.data._id,
        })
        .then((res) => {
          if (res.data.length) {
            landownerDetails.value = res.data[0].landownerId;
          }

          return res.data;
        });
    }

    return store.dispatch("estate/getSalesPersonEstates").then((res) => {
      landownerDetails.value = res.data.landownerId;
      return res.data.estateIds;
    });
  };
  const copyEstateLink = (estate: EstateInterface) => {
    const link = `${window.location.origin}/estate/${estate._id}`;

    copyToClipboard(link, "Estate map link was copied to clipboard");
  };

const __returned__ = { canEdit, store, estates, isSalesPersonRole, isLandownerRole, landownerDetails, lawyerName, isLawyerIdIsObject, loading, getEstates, copyEstateLink, computed, onMounted, ref, get EstateInterface() { return EstateInterface }, get useStore() { return useStore }, get getFirstLastName() { return getFirstLastName }, get copyToClipboard() { return copyToClipboard }, get formatStripePrice() { return formatStripePrice }, get getUserRole() { return getUserRole } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})